import React, { useState } from "react";
import { SimpleGrid, Stack } from "@mantine/core";
import { useTranslation } from "react-i18next";
import TitleWithInfoLink from "../new_test_ui/new_test_steps/common/TitleWithInfoLink";
import DeviceCard from "./DeviceCard";
import { productSort } from "../../utils/productUtils";
import { USER_GUIDE_DOC_URL } from "@constants/externalTutorialLinks";

export interface DeviceSelectorProps {
  devices: any[];
  onDeviceSelect: (device: any) => void;
  selectedDeviceId?: string | null;
  /** The modal that hosts the selector shows the title in its sticky header instead. */
  hideTitle?: boolean;
}

export default function DeviceSelector(props: DeviceSelectorProps) {
  const { t } = useTranslation();
  const [selectedDeviceId, setSelectedDeviceId] = useState<string | null>(
    props.selectedDeviceId || null,
  );

  const handleDeviceSelect = (device: any) => {
    setSelectedDeviceId(device.uuid);
    props.onDeviceSelect(device);
  };

  const sortedDevices = [...props.devices].sort(productSort);

  return (
    <Stack>
      {!props.hideTitle && (
        <TitleWithInfoLink
          title={t("SelectDevice")}
          tooltipText={t("InfoButtonTooltip")}
          link={USER_GUIDE_DOC_URL}
        />
      )}
      <SimpleGrid mb={"sm"} cols={{ base: 1, sm: 2 }} spacing={{ base: "sm", sm: "lg" }}>
        {sortedDevices.map((device) => (
          <DeviceCard
            key={device.uuid}
            product={device}
            status={device.status || device.deviceStatus || -1}
            isSelected={selectedDeviceId === device.uuid}
            onSelect={handleDeviceSelect}
          />
        ))}
      </SimpleGrid>
    </Stack>
  );
}
